
<template>
  <!--住户钥匙列表-->
  <div>
    <x-tabula
      ref="table"
      :initReqHandle="false"
      :dataSource="dataSource"
      rowKey="passKeyId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="true"
      @resetSearch = 'resetHandle'
    >
      <template slot="opt_o" slot-scope="{row}">
        <a-button v-hasPermi="['community:memberkey:member']" type="link" @click="toMemeberDetail(row.memberId)">{{row.mobile}}</a-button>
      </template>

      <template slot="opt_t" slot-scope="{row}">
        <div v-hasPermi="['community:memberkey:device']" @click="toDevDetail(row.deviceId)">
          <a-button type="link">{{row.deviceName}}</a-button>
          <br>
          <a-button type="link">{{row.devicePosition}}</a-button>
        </div>
      </template>

      <template slot="opt_h" slot-scope="{row}">
        <a-button v-hasPermi="['community:memberkey:apply']" type="link" @click="toApplyDetail(row.applyId)" :disabled="row.applyId==='0'">申请信息</a-button>
      </template>

      <template slot="opt_f" slot-scope="{row}">
        <span>{{row.expireTime | foreverTime}}</span>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect, defaultDate } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect, defaultDate],
  name: 'keyList',
  data () {
    return {
      cascadeParam: {},
      searchList: [
        { props: [`${this.$route.name}/communityId`], placeholder: '小区名称', options: [], inputType: 'select', handle: ($event) => this.communityChange(7, $event), fetchOptions: this.getOptions},
        { props: ['deviceSncode'], placeholder: '设备编码', options: [], inputType: 'input' },
        { props: ['deviceName'], placeholder: '设备名称', options: [], inputType: 'input' },
        { props: ['mobile'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: [`${this.$route.name}/createDate`], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' },
        {
          props: ['areaId'],
          placeholder: '省市',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(5, 'searchList', '1,2,3', e);
          }
        },
        { props: ['propertyId'], placeholder: '物业', options: [], inputType: 'select' },
        { props: [`${this.$route.name}/buildingId`], placeholder: '楼栋', options: [], inputType: 'select', handle: ($event) => this.buildingChange(8, $event) },
        { props: [`${this.$route.name}/unitId`], placeholder: '单元', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '钥匙状态', options: this.$store.state.isExpireList, inputType: 'select' }
      ],
      tableOptList: [
        { text: '分配钥匙', icon: 'setting', handle: this.toAlloc, permi: ['community:memberkey:add'] },
        { text: '批量分配', icon: 'setting', handle: this.toBatchAlloc, permi: ['community:memberkey:batchadd'] },
        { text: '删除', icon: 'colse', disabled: true, permi: ['community:memberkey:remove'] }
      ],
      rowOptList: [
        { text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), permi: ['community:memberkey:remove'] }
      ],
      columns: [
        { title: '住户', dataIndex: 'mobile', align: 'left', width: '', scopedSlots: {customRender: 'o'} },
        { title: '位置', dataIndex: 'keyPosition', align: 'left', width: '' },
        { title: '设备名称', dataIndex: 'deviceName', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '申请信息', dataIndex: 'apply_content', align: 'left', width: '', scopedSlots: {customRender: 'h'} },
        { title: '到期时间', dataIndex: 'expireTime', align: 'left', width: '', scopedSlots: {customRender: 'f'} },
        { title: '添加时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        [`${this.$route.name}/communityId`]: undefined,
        deviceSncode: undefined,
        deviceName: undefined,
        mobile: undefined,
        [`${this.$route.name}/createDate`]: [],
        areaId: [],
        propertyId: undefined,
        [`${this.$route.name}/buildingId`]: undefined,
        [`${this.$route.name}/unitId`]: undefined,
        status: undefined
      },
      listApi: {
        url: '/passKey/list',
        resHandle: '', // this.resHandle
        searchHandle: '', // searchHandle
        timeout: 1000 * 60 * 3
      },
      deleteParam: {
        url: '/passKey/',
        // param: { pk_key: 'passKeyId', pk_val: '' },
        title: '住户钥匙',
        key: 'keyPosition'
      }
    };
  },
  created () {
    this.getSelect();
  },
  mounted () {
    this.handleDefaultDate();
  },
  methods: {
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '0');
    },
    resetHandle () {
      this.searchList[7].options = [];
      this.searchList[8].options = [];
      this.communitySelectByStep(undefined, undefined, 'searchList', '0');
      this.searchList[0].searchValue = undefined;
    },
    getSelect () {
      // this.communitySelect(0, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', '0');
      this.propertySelect(6);
      this.regionSelect(5);
    },
    /* 进入分配钥匙 */
    toAlloc () {
      this.$router.push({
        name: 'allocation',
        query: { ...this.breadParam(this), title: '分配住户钥匙' }
      });
    },
    /* 进入批量分配钥匙 */
    toBatchAlloc () {
      this.$router.push({
        name: 'batchAllocation',
        query: this.breadParam(this)
      });
    },
    /* 进入钥匙申请记录详情 */
    toApplyDetail (id) {
      this.$router.push({
        name: 'keyApplyDetail',
        query: { id: id, ...this.breadParam(this) }
      });
    },
    /* 进入设备详情 */
    toDevDetail (id) {
      this.$router.push({
        name: 'smartDoorDetail',
        query: { id: id, ...this.breadParam(this) }
      });
    },
    /* 进入会员详情 */
    toMemeberDetail (id) {
      this.$router.push({
        name: 'memberDetail',
        query: { id: id, ...this.breadParam(this) }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
